export default __webpack_public_path__ + "static/media/gift-small.a363769d.svg";